import React, { useContext } from 'react'

import { IconButton } from '@driftt/dds'
import { faBell } from '@driftt/dds.icons/regular/faBell'

import PreferencesModal, { PrefrencesMenuItem } from 'components/PreferencesModal'
import { ICPSettingsContext } from 'context/icpSettingsContext'
import useSavedFilters from 'hooks/useSavedFilters'

const NotificationSettings = () => {
  const { showPreferencesModal, setShowPreferencesModal } = useContext(ICPSettingsContext)
  const { sharedFilters, privateFilters } = useSavedFilters()

  const handleNavigate = () => {
    setShowPreferencesModal(true)
  }

  return (
    <>
      <IconButton
        onClick={handleNavigate}
        size="default"
        variant="education"
        css={{
          height: '32px',
          width: '32px',
          '> svg': {
            height: '16px',
            width: '16px'
          }
        }}
        title="Notification Settings"
        icon={faBell}
      />
      <PreferencesModal
        open={showPreferencesModal}
        setModalOpen={setShowPreferencesModal}
        sharedFilters={sharedFilters}
        privateFilters={privateFilters}
        defaultTab={PrefrencesMenuItem.FILTERS}
      />
    </>
  )
}

export default NotificationSettings
